<template>
  <!-- Pie -->
  <div :id="chartInfo.nodeId"></div>
</template>

<script>
export default {
  name: "PieChart",
  props:["chartInfo","onClick"],
  data(){
    return {
    }
  },
  computed:{
    
  },
  methods:{
    pieChart(chartInfo){    
      console.log('pieChart>>>',this.chartInfo);
      this.$echarts.dispose(document.getElementById(chartInfo.nodeId));
      var myChart = this.$echarts.init(document.getElementById(chartInfo.nodeId));
      myChart.setOption({
          tooltip: {
            show: true,
            trigger: 'item'
          },
          legend: {
              show: false
          },
          series: [
              {
                  type: 'pie',
                  radius: ['45%', '60%'],
                  selectedMode: 'single',
                  selectedOffset: 10,
                  label: {
                      formatter: '{b}\n\n {d}'
                  },
                  labelLine: {
                      show: true
                  },
                  data: this.chartInfo?.data?.map((d) => {
                      return {
                          name: d.name,
                          value: d.value
                      }
                  }),
                  color: [
                      '#38a1ff',
                      '#daf4f9',
                      '#a1cff3'
                  ],
              }
          ]
        })    

        myChart.on('click', 'series', this.onClick);
    }
  },
  components:{
   
  },
  watch:{
    
  },
  mounted(){
    this.pieChart(this.chartInfo)
  }
}
</script>

<style scoped>
  

</style>